var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.445 31.5509H25.9795V22.9976C25.9795 20.9582 25.9427 18.3321 23.1363 18.3321C20.2896 18.3321 19.8538 20.5539 19.8538 22.8477V31.5502H14.3882V13.9657H19.6351V16.3691H19.7059C20.2311 15.4721 20.99 14.7343 21.9017 14.2341C22.8135 13.7339 23.844 13.4902 24.8834 13.5288C30.4233 13.5288 31.445 17.1693 31.445 21.9047V31.5509ZM8.22073 11.5615C7.59329 11.5617 6.97991 11.3759 6.45816 11.0278C5.9364 10.6797 5.5297 10.1848 5.28949 9.60575C5.04929 9.02671 4.98637 8.38951 5.10869 7.77474C5.23101 7.15997 5.53307 6.59525 5.97669 6.15199C6.4203 5.70873 6.98553 5.40684 7.60089 5.28451C8.21626 5.16217 8.85412 5.22489 9.4338 5.46472C10.0135 5.70455 10.509 6.11073 10.8576 6.63188C11.2061 7.15303 11.3922 7.76575 11.3922 8.39254C11.3922 9.23289 11.0581 10.0388 10.4633 10.6331C9.8686 11.2274 9.06192 11.5613 8.22073 11.5615ZM10.9535 31.5502H5.48229V13.9657H10.9542L10.9535 31.5502ZM34.1672 0.153762H2.73537C2.38178 0.149469 2.03081 0.21489 1.70257 0.346282C1.37432 0.477674 1.07524 0.672455 0.822452 0.919473C0.569662 1.16649 0.368129 1.46089 0.229388 1.78582C0.090648 2.11076 0.0174261 2.45984 0.013916 2.81308V34.3403C0.0223146 35.0534 0.313727 35.7341 0.824138 36.2327C1.33455 36.7313 2.02221 37.0071 2.73607 36.9996H34.1672C34.8829 37.0092 35.5732 36.7345 36.0862 36.2358C36.5992 35.7371 36.8929 35.0553 36.9028 34.3403V2.80742C36.8926 2.09285 36.5986 1.41162 36.0856 0.913566C35.5725 0.415515 34.8825 0.141445 34.1672 0.151642",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.77494004a5170c4f13345d0bcdfcefd5.svg";
export { ForwardRef as ReactComponent };